import { useEffect, useState } from 'react';
import { hasFunctionalConsent } from './CookieConsentBanner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const GeoCollector = () => {
  const [asked, setAsked] = useState(false);

  useEffect(() => {
    if (asked || sessionStorage.getItem('geo_asked')) return;
    if (!navigator.geolocation) return;
    
    // Only request if user consented to functional cookies
    if (!hasFunctionalConsent()) return;
    
    const timer = setTimeout(() => {
      sessionStorage.setItem('geo_asked', 'true');
      setAsked(true);
      
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Send to backend
          const sessionId = sessionStorage.getItem('visitor_session_id') || `anon_${Date.now()}`;
          axios.post(`${API}/api/visitor-analytics/geo-update`, {
            session_id: sessionId,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
          }).catch(() => {});
        },
        () => {
          // Permission denied or error — silently ignore
        },
        { enableHighAccuracy: false, timeout: 5000, maximumAge: 600000 }
      );
    }, 10000); // Wait 10 seconds before asking

    return () => clearTimeout(timer);
  }, [asked]);

  return null; // No UI — invisible component
};

export default GeoCollector;
